export default "__VITE_ASSET__BPND4c_W__"